import { useEffect, useRef, useState } from 'react';
import "./ResponseDetails.css";
import "../form-content/FormContent.css";
import { FormExtended, FormResponseExtended, Question, QuestionType } from 'effno-core';
import { apiGetQuestion } from '../../services/QuestionService';
import { ResponseDetailsMultiple } from './ResponseDetailsMultiple';
import { ResponseDetailsRating } from './ResponseDetailsRating';
import { ResponseDetailsScore } from './ResponseDetailsScore';
import { ResponseDetailsNPS } from './ResponseDetailsNPS';
import { ResponseDetailsGeneric } from './ResponseDetailsGeneric';
import { ResponseDetailsContact } from './ReportDetailsContact';
import { FormContentShort } from '../form-content/FormContentShort';
import { FormContentMultiple } from '../form-content/FormContentMultiple';
import { FormContentEmail } from '../form-content/FormContentEmail';
import { FormContentWebsite } from '../form-content/FormContentWebsite';
import { FormContentNumber } from '../form-content/FormContentNumber';
import { FormContentPhone } from '../form-content/FormContentPhone';
import { FormContentContact } from '../form-content/FormContentContact';
import { FormContentNPS } from '../form-content/FormContentNPS';
import { FormContentScore } from '../form-content/FormContentScore';
import { FormContentRating } from '../form-content/FormContentRating';
import { FormContentEnd } from '../form-content/FormContentEnd';
import { lightenColor } from '../shared/uiHelpers';
import { ICONS } from '../shared/media';
import { FormContentLong } from '../form-content/FormContentLong';
import { FormContentDate } from '../form-content/FormContentDate';

type ResponseDetailsProps = {
    form: FormExtended | null;
    originalFormName: string;
    responses: FormResponseExtended[] | null;
    questionId: string;
    onClose: () => void;
}

export const ResponseDetails = ({
    form,
    originalFormName,
    responses,
    questionId,
    onClose
    } : ResponseDetailsProps) => {

    const divRef = useRef(null);
    // const closeRef = useRef(null);
    
    const [question, setQuestion] = useState<Question | null>(null);
    

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("mousedown", handleMouseDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mousedown", handleMouseDown);
        }
    }, []);

    useEffect(() => {
        if (questionId) {
            (async () => {
                const theQuestion = await apiGetQuestion(questionId);
                setQuestion(theQuestion);
            })();
        }
    }, [questionId]);

    const handleKeyDown = (e: any) => {
        if (e.key === "Escape") {
            onClose();
        }
    }

    // check for clickout
    const handleMouseDown = (e: any) => {
        const div = divRef.current as any;
        // const closeDiv = closeRef.current as any;

        if (div && !div.contains(e.target)) {
            onClose();
        }

        // if (closeDiv && closeDiv.contains(e.target)) {
        //     onClose();
        // }

        // console.log("Close div: ", closeDiv);
        // console.log("Target: ", e.target);
        console.log("No clickout")
    }

    const parentComments = question ? question.comments.filter((comment) => !comment.parentQuestionCommentId) : [];

    const formTheme = form?.formTheme;
    const formThemeSettings = formTheme?.settings ? JSON.parse(formTheme.settings) : {};

    const brightness = formThemeSettings.imageBrightness || 1.0;

    // const formThemeStyle = { 
    //     "--ftBackgroundColor": formThemeSettings?.backgroundColor || "var(--background-color-primary)",
    //     "--ftQuestionColor": formThemeSettings?.questionColor || "var(--text-color-primary)",
    //     "--ftAnswerColor": formThemeSettings?.answerColor || "var(--text-color-primary)",
    //     "--ftAnswerBackgroundColor": formThemeSettings?.answerColor ?
    //         lightenColor(formThemeSettings?.answerColor, 80) :
    //         "var(--background-color-tertiary)",
    //     "--ftFont": formThemeSettings?.font || "var(--font-primary)",
    //     "--ftButtonColor": formThemeSettings?.buttonColor || "var(--button-color-primary)",
    //     "--ftButtonTextColor": formThemeSettings?.buttonTextColor || "var(--button-text-primary)",
    //     "--ftBackgroundImage": `url(${formThemeSettings?.backgroundImage || ""})`, 
    //     "--ftImageBrightness": `brightness(${brightness})`,
    //     "--ftImageOpacity": `${brightness}`,
    // } as React.CSSProperties

    const formThemeStyle = { 
        "--ftBackgroundColor": formThemeSettings?.backgroundColor || "var(--default-ftBackgroundColor)",
        "--ftQuestionColor": formThemeSettings?.questionColor || "var(--default-ftQuestionColor)",
        "--ftAnswerColor": formThemeSettings?.answerColor || "var(--default-ftAnswerColor)",
        "--ftAnswerBackgroundColor": formThemeSettings?.answerColor ?
            lightenColor(formThemeSettings?.answerColor, 80) :
            "var(--default-ftAnswerBackgroundColor)",
        "--ftFont": formThemeSettings?.font || "var(--default-ftFont)",
        "--ftButtonColor": formThemeSettings?.buttonColor || "var(--default-ftButtonColor)",
        "--ftButtonTextColor": formThemeSettings?.buttonTextColor || "var(--default-ftButtonTextColor)",
        "--ftBackgroundImage": `url(${formThemeSettings?.backgroundImage || ""})`, 
        "--ftImageBrightness": `brightness(${brightness})`,
        "--ftImageOpacity": `${brightness}`,
    } as React.CSSProperties

    const questionOrder = form?.questionOrder ? JSON.parse(form.questionOrder) : [];
    const questionNumber = question ? questionOrder.indexOf(question.id) + 1 : 0;

    const showQuestionNumber = form?.formSettings && form.formSettings.questionNumbers &&
        question?.type !== QuestionType.END && question?.type !== QuestionType.SECTION;

    console.log("[ResponseDetails] questionId: ", questionId);

    return (
        <div 
            className="response-details"
            ref={divRef}
            style={formThemeStyle}
        >
            {form && 
                <>
                    <div className="response-details-header">
                        <div className="response-details-title">
                            {(originalFormName).substring(0, 60)} 
                            {originalFormName.length > 60 ? "..." : ""}
                        </div>
                        <div 
                            className="response-details-close"
                            // ref={closeRef}
                            onClick={onClose}
                        >
                            <img className="icon-close" />
                        </div>
                    </div>

                    {question &&
                        <div className="response-details-original">
                            <div 
                                className="form-content-laptop"
                                style={{
                                    width: "100%",
                                    height: "400px",
                                    overflowY: "hidden",
                                    position: "relative",
                                }}

                            >
                                <div 
                                    className="form-content-container"
                                    style={{pointerEvents: "none"}}
                                >
                                    {showQuestionNumber &&
                                        <div className="form-content-pointer">
                                            {questionNumber} {"->"}
                                        </div>
                                    }
                        
                                    {(
                                        () => {
                                            switch(question?.type) {
                                                case QuestionType.SHORT:
                                                    return (
                                                        <FormContentShort 
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.LONG:
                                                    return (
                                                        <FormContentLong
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.MULTIPLE:
                                                    return (
                                                        <FormContentMultiple 
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )      
                                                case QuestionType.DATE:
                                                    return (
                                                        <FormContentDate 
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.EMAIL:
                                                    return (
                                                        <FormContentEmail      
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )  
                                                case QuestionType.FILE_UPLOAD:
                                                    return (
                                                        <FormContentShort      
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.WEBSITE:
                                                    return (
                                                        <FormContentWebsite      
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.NUMBER:
                                                    return (
                                                        <FormContentNumber      
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.PHONE:
                                                    return (
                                                        <FormContentPhone      
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.CONTACT:
                                                    return (
                                                        <FormContentContact      
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.NPS:
                                                    return (
                                                        <FormContentNPS 
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.SCORE:
                                                    return (
                                                        <FormContentScore      
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                case QuestionType.RATING:
                                                    return (
                                                        <FormContentRating 
                                                            question={question}
                                                            allowSaving={false}
                                                        />
                                                    )
                                                // case QuestionType.END:
                                                //     return (
                                                //         <FormContentEnd question={question} />
                                                //     )
                                                default:
                                                    return (
                                                        <div>
                                                            NO ORIGINAL QUESTION
                                                        </div>
                                                    );
                                            }
                                        }
                                    )()}
                                </div>
                            </div>
                        </div>
                    }

                    {/* <span>questionId {questionId}</span> */}

                    {question && (
                        () => {
                            switch(question.type) {
                                case QuestionType.SHORT:
                                case QuestionType.LONG:
                                    return (
                                        <ResponseDetailsGeneric 
                                            question={question}
                                            responses={responses}
                                            valueName="text"
                                        />
                                    ) 
                                case QuestionType.DATE:
                                    return (
                                        <ResponseDetailsGeneric 
                                            question={question}
                                            responses={responses}
                                            valueName="date"
                                        />
                                    ) 
                                case QuestionType.EMAIL:
                                    return (
                                        <ResponseDetailsGeneric 
                                            question={question}
                                            responses={responses}
                                            valueName="email"
                                        />
                                    ) 
                                case QuestionType.WEBSITE:
                                    return (
                                        <ResponseDetailsGeneric 
                                            question={question}
                                            responses={responses}
                                            valueName="URL"
                                        />
                                    ) 
                                case QuestionType.NUMBER:
                                    return (
                                        <ResponseDetailsGeneric 
                                            question={question}
                                            responses={responses}
                                            valueName="number"
                                        />
                                    ) 
                                case QuestionType.PHONE:
                                    return (
                                        <ResponseDetailsGeneric 
                                            question={question}
                                            responses={responses}
                                            valueName="phone"
                                        />
                                    ) 
                                case QuestionType.CONTACT:
                                    return (
                                        <ResponseDetailsContact 
                                            question={question}
                                            responses={responses}
                                        />
                                    ) 
                                case QuestionType.MULTIPLE:
                                    return (
                                        <ResponseDetailsMultiple 
                                            question={question}
                                            responses={responses}
                                        />
                                    )      
                                case QuestionType.NPS:
                                    return (
                                        <ResponseDetailsNPS 
                                            question={question}
                                            responses={responses}
                                        />
                                    ) 
                                case QuestionType.SCORE:
                                    return (
                                        <ResponseDetailsScore 
                                            question={question}
                                            responses={responses}
                                        />
                                    ) 
                                case QuestionType.RATING:
                                    return (
                                        <ResponseDetailsRating 
                                            question={question}
                                            responses={responses}
                                        />
                                    ) 
                                case QuestionType.SECTION:
                                case QuestionType.END:
                                    return (
                                        <span>{question.type} is boring </span>
                                    )
                                case QuestionType.FILE_UPLOAD:
                                default:
                                    return (
                                        <div>
                                            Defaulted for some reason
                                        </div>
                                    );
                            }
                        }
                    )()
                    }
                </>
            }

        </div>
    )
}